<template>
  <div class="hero">
    <div class="bg" v-bind:style="{ backgroundImage: 'url(' + bgimage + ')' }">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <Title ref="title" v-bind:title="title"></Title>
          </div>
          <div class="col-sm-6">
            <p ref="text" v-html="text"></p>
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/Title'
import { TweenMax, Power0, Power1 } from "gsap";
import TimelineMax from "gsap/TimelineMax";

export default {
  name: 'Banner',
  props: {
    title: String,
    text: String,
    bgimage: String,
    bus: {}
  },
  data() {
    return {
       timelines: []
    }
  },
  methods: {
    TimeLineFactory(conf) {
      conf = conf || {}
      let t = new TimelineMax(conf)
      this.timelines.push(t)
      return t
    }
  },
  components: {
    Title
  },
  mounted() {
    require("@/js/vendor/SplitText.js")

    this.$nextTick(() => {

      const tl = this.TimeLineFactory({
        paused: true
      })
      let titlesplit = new SplitText(
        this.$refs.title.$el.querySelector('.title h1, .astitle'),
        { type: "chars" })
      let text = this.$refs.text

      TweenMax.set(titlesplit.chars, {opacity: 0})
      TweenMax.set(text, {opacity: 0})

      tl.staggerFromTo(titlesplit.chars, 0.6, 
        {
          yPercent: 20
        },
        {
          ease: Power0.easeOut,
          yPercent: 0,
          opacity: 1
        }, 0.03, '-=0.2')
      tl.fromTo(text, 1, 
        {
          yPercent: 6
        },
        {
          ease: Power1.easeOut,
          yPercent: 0,
          opacity: 1
        }, '-=0.3')
      this.bus.$on('pagechange', data => {
        if (data == this.$el) {
          tl.play().timeScale(1)
        } else {
          tl.reverse().timeScale(2)
        }
      })
    })
  }
}
</script>

<style scoped lang="scss">
.bg {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.hero {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>

